import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutZipZoneList extends Layout {
    labelSearchZipZone: Label;
    mapRoute: Map;
    sourceZipzone: DataSource;
    splitterZipZone: Splitter;
    tableZipZoneList: Table;
}
